import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { VersionConfig } from '../../models/version-config.model';

export { VersionConfig, VersionConfigData } from '../../models/version-config.model';

const DEFAULT_CONFIG: VersionConfig = {
  newestVersion: '0.0.0',
  availableVersions: [],
  loaded: false
};

@Injectable({ providedIn: 'root' })
export class VersionConfigStorage {
  private readonly config$: BehaviorSubject<VersionConfig> = new BehaviorSubject<VersionConfig>(DEFAULT_CONFIG);

  getLoadedConfig$(): Observable<VersionConfig> {
    return this.config$.pipe(filter((config: VersionConfig) => config.loaded));
  }

  setConfig(newestVersion: string, availableVersions: string[]): void {
    this.config$.next({ newestVersion, availableVersions, loaded: true });
  }

  isLoaded(): boolean {
    return this.config$.getValue().loaded;
  }
}
